import { render, staticRenderFns } from "./CoachOrders.vue?vue&type=template&id=5368d979&scoped=true"
import script from "./CoachOrders.vue?vue&type=script&lang=js"
export * from "./CoachOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5368d979",
  null
  
)

export default component.exports